import { render, staticRenderFns } from "./ChatContainer.vue?vue&type=template&id=3b1786bc&"
import script from "./ChatContainer.vue?vue&type=script&lang=ts&"
export * from "./ChatContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ChatContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports